import { Controller, useFormContext } from "react-hook-form";
import type {
  ControllerRenderProps,
  FieldPath,
  FieldValues,
} from "react-hook-form";

export type FieldComponentProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = ControllerRenderProps<TFieldValues, TName> & {
  errorMessage?: string;
  disabled: boolean;
};

interface FormFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> {
  name: TName;
  render: (
    props: FieldComponentProps<TFieldValues, TName>,
  ) => React.ReactElement;
}

export function FormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, render }: FormFieldProps<TFieldValues, TName>) {
  const { control, formState } = useFormContext<TFieldValues>();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) =>
        render({
          ...field,
          errorMessage: fieldState.error?.message,
          disabled: formState.isSubmitting,
        })
      }
    />
  );
}
